// src/shared/components/ui/LoadingSpinner.jsx
import React from 'react';
import styles from './LoadingSpinner.module.css';

/**
 * مؤشر تحميل
 * @param {'sm'|'md'|'lg'} size
 * @param {string}          message
 * @param {boolean}         fullPage  - يملأ الشاشة كاملاً
 */
const LoadingSpinner = ({
  size     = 'md',
  message  = 'جاري التحميل...',
  fullPage = false,
}) => (
  <div className={`${styles.container} ${fullPage ? styles.fullPage : ''}`}>
    <div className={`${styles.spinner} ${styles[size]}`} />
    {message && <p className={styles.message}>{message}</p>}
  </div>
);

export default LoadingSpinner;